export default __webpack_public_path__ + "static/media/qaicon.1e90c88b.svg";